<template>
  <div class="grid grid-cols-6 gap-6">
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="alias" class="block text-sm font-medium text-gray-700">Alias</label>
      <input type="text" id="alias" :value="loadData.alias"
             @change="(aliasNew)=>$emit('updateValues', {'alias': aliasNew.target.value})"
             class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="name" class="block text-sm font-medium text-gray-700">Nombre</label>
      <input type="text" id="name" :value="loadData.name"
             @change="(nameNew)=>$emit('updateValues', {'name': nameNew.target.value})"
             class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="menu_padre_id" class="block text-sm font-medium text-gray-700">Nombre del menu</label>
      <select id="menu_padre_id" :value="loadData.menu_padre_id"
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              @change="(idMenuNew)=>$emit('updateValues', {'menu_padre_id': idMenuNew.target.value})">
        <option value="" selected>Seleccione un menu...</option>
        <option v-for="(menu, index) of collectionMenus" :key="'B'+index" :value="menu.id">{{
            menu.name
          }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MenusCrearActualizarComponent',
  props: ['loadData', 'collectionMenus', 'customUpdateValueData'],
  emits: ["updateValues"],
}
</script>